import { render } from "./AdminMediaUpload.vue?vue&type=template&id=5ac52268&scoped=true&ts=true"
import script from "./AdminMediaUpload.vue?vue&type=script&lang=ts"
export * from "./AdminMediaUpload.vue?vue&type=script&lang=ts"

import "./AdminMediaUpload.vue?vue&type=style&index=0&id=5ac52268&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ac52268"]])

export default __exports__